import React from "react";

import { percentage } from "lib/common";

import { aspectType } from "lib/store/dashboard";

import { Label } from "components/atom/Label";

import "./SentimentStackedBarChart.scss";

export const SentimentStackedBarChart: React.FC<aspectType> = ({
  aspect,
  negative,
  positive,
  neutral,
}) => {
  const max = negative + positive + neutral;

  return (
    <div className={"SentimentStackedBarChart"}>
      <Label>{aspect}</Label>
      <div className="chart">
        {max === 0 ? (
          <>
            <div className={"positive"} style={{ width: "100%" }} />
            <div className={"neutral"} style={{ width: `100%` }} />
            <div className={"negative"} style={{ width: `100%` }} />
          </>
        ) : (
          <>
            <div
              className={`positive ${
                positive >= negative && positive >= neutral ? "longer" : ""
              }`}
              style={{ width: `${percentage(positive / max)}%` }}
            />
            <div
              className={`neutral ${
                neutral >= negative && neutral >= positive ? "longer" : ""
              }`}
              style={{ width: `${percentage(neutral / max)}%` }}
            />
            <div
              className={`negative ${
                negative >= neutral && negative >= positive ? "longer" : ""
              }`}
              style={{ width: `${percentage(negative / max)}%` }}
            />
          </>
        )}
      </div>
    </div>
  );
};
